export const FEED_GENERIC_ERROR = 'Something went wrong';

// The API relays Google errors verbatim as "Merchant API returned <status>: <json>"
const GOOGLE_ERROR_BODY = /^Merchant API returned \d+:\s*(\{[\s\S]*\})\s*$/;

export const getFeedErrorMessage = (error, fallback = FEED_GENERIC_ERROR) => {
    const message = error?.response?.data?.message;

    if (!message || typeof message !== 'string') return fallback;

    const match = message.match(GOOGLE_ERROR_BODY);

    if (!match) return message;

    try {
        return JSON.parse(match[1])?.error?.message || message;
    } catch {
        return message;
    }
};
